import { Helmet } from "react-helmet"

export const Head = () => {
  return (
    <Helmet>
        <title>DIRECTORS</title>
        <meta name="description" content="Meet our directors who bring a wealth of experience and expertise to the team. Each director is dedicated to driving our mission and vision forward, ensuring that we continue to deliver value and maintain our commitment to excellence." />
    </Helmet>
  )
}
